import * as React from 'react';
import { withRouter } from 'react-router-dom';

import { EError } from '@enums';

import { Translate } from '@decorators';

import { SharePage } from '@common/components/SharePage';
import { AppStat } from '@common/utils/AppStat';

import { IErrorProps } from './types';

import * as s from './Error.scss';

interface IErrorDescription {
	title: string | React.ReactNode;
	text: string | React.ReactNode;
}

@Translate('common.components.Error')
export class ErrorComponent extends React.Component<IErrorProps> {

	componentDidMount() {
		const { error } = this.props;

		AppStat.log.share.errorOpen({ error });
	}

	isMobileVerticalStoreIcons() {
		const { error } = this.props;

		return [
			EError.INTERNAL_SERVER_ERROR,
			EError.BAD_GATEWAY,
		].includes(error as EError);
	}

	getErrorDescription(error: string): IErrorDescription {
		switch (error) {
			case EError.FORBIDDEN:
				return {
					title: this.t(`forbidden.title`),
					text: this.t('forbidden.text'),
				};

			case EError.PAGE_NOT_FOUND:
				return {
					title: this.t(`pageNotFound.title`),
					text: this.t('pageNotFound.text'),
				};

			case EError.INTERNAL_SERVER_ERROR:
				return {
					title: this.t(`internalServerError.title`),
					text: this.t('internalServerError.text'),
				};

			case EError.BAD_GATEWAY:
				return {
					title: this.t(`badGateway.title`),
					text: this.t('badGateway.text'),
				};

			default:
				return {
					title: this.t('default.title'),
					text: this.t('default.text'),
				};
		}
	}

	renderContent() {
		const { error } = this.props;
		const { title, text } = this.getErrorDescription(error);

		return (
			<div className={s.content}>
				<div className={s.title}>{title}</div>
				<div className={s.text}>{text}</div>
			</div>
		);
	}

	render() {
		return (
			<SharePage
				gradientColor="#ED0F23"
				gradientStart={-50}
				pictureContent={this.renderContent()}
				isHidePicture={true}
				isHidePlay={true}
				isMobileVerticalStoreIcons={this.isMobileVerticalStoreIcons()}
			/>
		);
	}

}

export const Error = withRouter(ErrorComponent);
